import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

// Bridge component for presenting web content in a native sheet.
// On native: sends the sheet type and URL to iOS which presents the
// appropriate native modal (bottom_sheet, full_screen, or alert).
// On web: this controller is not used (standard web modals handle it).
//
// Usage:
//   <%= tag.div(
//     data: {
//       controller: "bridge--sheet",
//       bridge__sheet_type_value: "bottom_sheet",
//       bridge__sheet_url_value: welcome_path,
//       bridge__sheet_title_value: "Bienvenue",
//     },
//   ) %>
//
// Types:
//   - bottom_sheet: half-screen sheet with grabber, expandable
//   - full_screen: full screen modal with close button
//   - alert: compact centered sheet (~300pt)
//
// Omit the bridge component entirely for standard web modals.
export default class extends BridgeComponent {
  static component = 'sheet';
  static values = {
    type: { type: String, default: 'bottom_sheet' },
    url: String,
    title: { type: String, default: '' },
  };

  connect() {
    super.connect();
    this.send(
      'display',
      {
        type: this.typeValue,
        url: this.urlValue,
        title: this.titleValue,
      },
      () => {
        this.handleDismiss();
      },
    );
  }

  handleDismiss() {
    this.element.remove();
  }
}
